export default "__VITE_ASSET__8Y8p2GYQ__"